import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

import { getInitialDictionariesLoaded } from "../../modules/info-data/info-data-selectors";
import { loadDictionariesAction } from "../../reducers";
import { useAppDispatch } from "../../store";

/** Подтягивает справочники после авторизации, ровно один раз. */
export function useDictionaryLoader(isAuthenticated: boolean): boolean {
  const initialDictionariesLoaded = useSelector(getInitialDictionariesLoaded);
  const dispatch = useAppDispatch();

  const fetchDictionaries = useCallback(() => {
    if (initialDictionariesLoaded) {
      return; // avoid duplicate network requests
    }
    dispatch(loadDictionariesAction());
  }, [dispatch, initialDictionariesLoaded]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchDictionaries();
    }
  }, [isAuthenticated, fetchDictionaries]);

  return initialDictionariesLoaded;
}
